<template>
  <div class="product">
    <div class="wrapper">
      <TopNav :current-lang="'cn'" :current-page="'product'"></TopNav>
      <div class="feature" ref="featureRef">
        <div class="row-wrapper">
          <div class="row">
            <div class="intro">
              <h3>梦之蓝M9</h3>
              <h4>顶级</h4>
              <p>百里挑一，小坛窖藏，温润如玉，方为梦九。</p>
              <p>梦之蓝M9产自梦之蓝中央酒区核心区，主体基酒都是小坛藏足8年以上的陈年酒，辅以10年以上不同风格窖藏陈年调味酒精心雕琢，看起来色泽微黄，闻起来自然陈香，喝下去温润如玉。</p>
              <div class="buy-now-btn" @click="navTo('','','#purchase')">立即购买 ></div>
            </div>
            <div class="img">
              <img src="../assets/imgs/product/d/1.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="img">
              <img src="../assets/imgs/product/d/2.jpg" alt="">
            </div>
            <div class="intro">
              <h3>工艺</h3>
              <p>
                精选原料：梦之蓝M9采用最优质的高粱、大米、小麦等原料，确保酒体的纯净和高品质。
              </p>
              <p>
                传统工艺与现代技术结合：传承洋河酒厂的经典酿造工艺，并结合现代科技，优化发酵和蒸馏过程，保证每一瓶酒的卓越品质。
              </p>
              <p>
                长时间陈酿：经过长时间的窖藏陈酿，使酒体更加醇厚，风味更加复杂。
              </p>
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="intro">
              <h3>口感</h3>
              <p>
                丰满酒体：梦之蓝M9酒体丰满，香气浓郁，带有花香、果香和粮香的多层次香气。
              </p>
              <p>
                丝滑入口：入口柔顺，质感如丝绸般顺滑，适口性极佳。
              </p>
              <p>
                回味悠长：具有悠长而丰富的回味，层次分明，余味绵长且令人愉悦。
              </p>
            </div>
            <div class="img">
              <img src="../assets/imgs/product/d/3.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="img">
              <img src="../assets/imgs/product/d/4.jpg" alt="">
            </div>
            <div class="intro">
              <h3>外观</h3>
              <p>
                精美瓶身设计：瓶身设计精美，融合传统与现代元素，采用高档材料，体现出奢华与典雅的风格。
              </p>
              <p>
                高端包装：包装设计考究，精致豪华，适合作为高端礼品。
              </p>
              <p>
                独特标识：瓶身和包装上有显著的梦之蓝品牌标识，象征高品质和尊贵。
              </p>
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="intro">
              <h3>其他</h3>
              <p>
                限量生产：梦之蓝M9产量有限，具有很高的稀有性和收藏价值。
              </p>
              <p>
                品牌形象：作为洋河酒厂顶级产品之一，梦之蓝M9代表了洋河酒的最高水平和品牌形象。
              </p>
              <p>
                文化传承：体现了洋河酒厂深厚的文化底蕴和卓越的酿造工艺，传承与创新相结合。
              </p>
            </div>
            <div class="img">
              <img src="../assets/imgs/product/d/5.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="consumer" ref="consumerRef">
        <h1>适合的消费者和消费场景</h1>
        <div class="group-wrapper">
          <div class="group">
            <img src="../assets/imgs/tc-swrs.png" alt="">
            <p>
              商务人士
            </p>
          </div>
          <div class="group">
            <img src="../assets/imgs/tc-gdsj.png" alt="">
            <p>
              高端社交
            </p>
          </div>
          <div class="group">
            <img src="../assets/imgs/tc-gdlp.png" alt="">
            <p>
              高端礼品
            </p>
          </div>
        </div>
      </div>
      <PurchaseCn></PurchaseCn>
      <div class="like" ref="likeRef">
        <h1>猜你喜欢</h1>
        <div class="recommend-wrapper">
          <div class="recommend">
            <a href="/cn/product/Sky-Blue"><img src="../assets/imgs/product/rec/h.png" alt=""></a>
            <p><a href="/cn/product/Sky-Blue">天之蓝</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Sea-Blue"><img src="../assets/imgs/product/rec/i.png" alt=""></a>
            <p><a href="/cn/product/Sea-Blue">海之蓝</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Micro-Molecules"><img src="../assets/imgs/product/rec/1.png" alt=""></a>
            <p><a href="/cn/product/Micro-Molecules">微分子</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Dream-of-Blue-Crystal-Edition"><img src="../assets/imgs/product/a/1.jpg" alt=""></a>
            <p><a href="/cn/product/Dream-of-Blue-Crystal-Edition">梦之蓝水晶版</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Dream-of-Blue-M6+"><img src="../assets/imgs/product/rec/3.png" alt=""></a>
            <p><a href="/cn/product/Dream-of-Blue-M6+">梦之蓝M6+</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Dream-of-Blue-Handmade-Edition"><img src="../assets/imgs/product/rec/4.png"
                                                                        alt=""></a>
            <p><a href="/cn/product/Dream-of-Blue-Handmade-Edition">梦之蓝手工班</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Yanghe-Daqu-New-Sky-Blue"><img src="../assets/imgs/product/rec/5.png" alt=""></a>
            <p><a href="/cn/product/Yanghe-Daqu-New-Sky-Blue">洋河大曲新天蓝</a></p>
          </div>
          <div class="recommend">
            <a href="/cn/product/Blue-Classic"><img src="../assets/imgs/product/rec/6.png" alt=""></a>
            <p><a href="/cn/product/Blue-Classic">蓝色经典</a></p>
          </div>
          <!--          <div class="recommend">-->
          <!--            <img src="../assets/imgs/product/rec/7.png" alt="">-->
          <!--            <p>梦之蓝M9</p>-->
          <!--          </div>-->
        </div>
      </div>
      <BottomNav :current-lang="'cn'" :current-page="'product'"></BottomNav>
      <!-- 遮罩 -->
      <!--      <div class="mask" v-show="isMask">-->
      <!--        <img id="load1" alt="" src="../assets/imgs/load.gif" class="mask__load"/>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
// import {zoomElement} from '@/utils/zoom.js';
import {minxin} from "@/utils/minxin";
import TopNav from "@/components/TopNav";
import BottomNav from "@/components/BottomNav";
import PurchaseCn from "@/components/PurchaseCn";

export default {
  name: "Home", //翻页
  mixins: [minxin],
  props: [],
  components: {
    PurchaseCn,
    BottomNav,
    TopNav,
  },
  data() {
    return {
      timer: null, // 定时器
      isMask: true, //显示遮罩
    }
  },
  created() {
    const that = this;
    console.log(window.location.hash);
  },
  mounted() {
    const that = this;
    // 监听 resize 方法
    window.addEventListener("resize", that.renderResize, false);

    that.timer = setInterval(function () {
      // console.log("document.readyState === 2", document.readyState)
      if (document.readyState === 'complete') {
        that.isMask = false;
        window.clearInterval(that.timer)

        //获取需要缩放的dom元素
        // let zoomEl = that.$refs.;
        // console.log("zoomEl:" + zoomEl);
        // zoomElement(zoomEl);
      }
    }, 2000);
    window.scrollTo(0, 0);
  },
  beforeCreate() {
  },
  beforeDestroy() {
    const that = this;
    // 移除监听
    window.removeEventListener("resize", that.renderResize, false)
  },
  computed: {},
  methods: {
    renderResize() {
      console.log('on resize');
      const that = this;

      that.$nextTick(() => {
        console.log('on resize $nextTick');
        that.$forceUpdate();
      });

      // 做页面适配
      // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
    },
  },
  metaInfo: {
    title: 'YANGHE.SG',
    meta: [
      {
        name: 'keywords',
        content: 'YANGHE, Dream of Blue M9, 洋河, 梦之蓝M9'
      },
      {
        name: 'description',
        content: 'YANGHE, Dream of Blue M9, 洋河, 梦之蓝M9'
      }
    ]
  }
}
</script>
<style lang="less" scoped>

.product {
  background-color: rgba(255, 255, 255, 0.55);
  position: relative;
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0; //固定元素,不被挤压

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1920PX;
    width: 100%;

    .feature {
      width: 100%;
      padding-bottom: 48px;
      text-align: left;

      .row-wrapper {
        margin: 0 auto;

        .row {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-evenly;
          justify-items: flex-start;
          padding-top: 50px;
          padding-bottom: 50px;
          width: 100%;

          .intro {
            width: 35%;
            margin-bottom: 60px;
            text-align: left;

            h3 {
              font-size: 32px;
              font-weight: bold;
              margin-left: 12px;
              margin-right: 12px;
            }

            h4 {
              color: #d5bb8e;
              font-size: 18px;
              font-weight: normal;
              margin-left: 12px;
              margin-right: 12px;
            }

            p {
              font-size: 22px;
              margin-left: 12px;
              margin-right: 12px;
            }
          }

          .img {
            width: 360px;
            height: 360px;
            border: 1px solid #0634ad;
            //box-shadow: 2px 2px 2px 2px rgba(6, 52, 173, .2);
            background-color: #ffffff;
            //padding: 30px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

      }

      .row-wrapper:nth-child(even) {
        background-color: #ebeff1;

        h3 {
          color: #01aaf4;
        }
      }

      .buy-now-btn {
        background-color: #01aaf4;
        border-radius: 4px;
        width: 116px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: normal;
        color: #ffffff;
        display: block;
        text-align: center;
        margin-left: 10px;;
        margin-top: 60px;
        cursor: pointer;
      }
    }

    .consumer {
      display: block;
      background-color: #ebeff1;
      width: 100%;
      padding-top: 40px;
      padding-bottom: 40px;

      .group-wrapper {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-wrap: wrap;
        justify-content: space-evenly;
        justify-items: flex-start;
        background-color: #ebeff1;
        width: 80%;
        margin: 0 auto;

        .group {
          width: 300px;
          height: 329px;

          img {
            width: 206px;
            height: 206px;
          }

          p {
            color: #666666;
            font-size: 22px;
            line-height: 28px;
            text-align: center;
            //padding-top: 50px;
          }
        }
      }

      h1 {
        font-size: 32px;
        color: #01aaf4;
        text-align: center;
        padding-right: 20px;
        padding-bottom: 40px;
      }
    }

    .like {
      padding-bottom: 48px;

      h1 {
        font-size: 34px;
        font-weight: bold;
      }

      .recommend-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: flex-start;
        padding-left: 140px;
        padding-right: 140px;
        padding-top: 30px;

        .recommend {
          width: 26%;
          margin-bottom: 40px;
          text-align: center;

          img {
            width: 250px;
            height: 250px;
            border: 1px solid #0634ad;
          }

          p {
            font-size: 18px;
            margin-left: 12px;
            margin-right: 12px;
          }

          a:link {
            color: #2c3e50;
            text-decoration: none;
          }

          a:visited {
            color: #2c3e50;
          }

          a:hover {
            color: #d5bb8e;
            cursor: pointer;
          }
        }

      }

      .view-more-btn {
        background-color: #01aaf4;
        border-radius: 4px;
        width: 116px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        display: block;
        text-align: center;
        margin: 0 auto;
      }
    }
  }

  .mask {
    z-index: 1000;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100vw;
    background-color: #BDE4E6;
    display: flex;
    justify-content: center;
    align-items: center;

    .mask__load {
      width: 300px;
      margin-bottom: 100px;
    }
  }
}

@media only screen and (max-width: 820px) {

  .product {
    .wrapper {
      width: 100%;

      .feature {

        .row-wrapper {
          .row {
            .intro {
              width: 50%;

              h3 {
                font-size: 60px;
                line-height: 60px;
              }

              h4 {
                font-size: 40px;
                line-height: 40px;
              }

              p {
                font-size: 44px;
              }
            }

            .img {
              width: 25%;
              height: 25%;
            }
          }

        }

        .buy-now-btn {
          border-radius: 12px;
          width: 330px;
          height: 68px;
          line-height: 68px;
          font-size: 34px;
        }
      }

      .consumer {

        h1 {
          font-size: 60px;
          line-height: 60px;
        }

        h2 {
          font-size: 42px;
          line-height: 42px;
        }

        .group-wrapper {
          .group {
            height: 400px;
            width: 45%;

            p {
              font-size: 36px;
              line-height: 54px;
            }
          }
        }
      }

      .like {
        h1 {
          font-size: 72px;
        }

        .recommend-wrapper {
          .recommend {
            img {
              width: 320px;
              height: 320px;
              border: 1px solid #0634ad;
            }

            p {
              font-size: 28px;
              margin-left: 12px;
              margin-right: 12px;
            }
          }

        }

        .view-more-btn {
          background-color: #01aaf4;
          border-radius: 4px;
          width: 116px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          display: block;
          text-align: center;
          margin: 0 auto;
        }
      }

    }
  }
}

@media only screen and (max-width: 1440px) {
}
</style>
